import { AxiosStatic } from "axios";
import { TimeService } from "../../time";
import { FeedbackFn, FeedbackPayload, RawFeedbackFn } from "./feedback";
import { JwtTokenFn } from "@me8eon/authentication";


export type FeedbackToEsType = FeedbackPayload & {
    env: string;
    sessionId: string;
    timestamp: number;
}
export const defaultFeedbackFn =
    (nodeServiceBaseUrl: string, envName: () => string, axios: AxiosStatic, index: string): RawFeedbackFn =>
        (sessionId: string, accessToken: JwtTokenFn, timeService: TimeService): FeedbackFn =>
            async (p: FeedbackPayload) => {
                void index; // kept for call-signature compatibility with prior ES-index wiring
                const payload: FeedbackToEsType = {
                    ...p,
                    env: envName(),
                    sessionId,
                    timestamp: timeService().getTime(),
                };
                const token = await accessToken();
                if (token)
                    return axios.post(`${nodeServiceBaseUrl}/service/feedback`, payload, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    });
                else throw new Error("Called feedback fn without token");
            };